module.exports = __webpack_public_path__ + "img/arrow-right-square.2321d8bf.svg";